import React from 'react'
import Settings1 from './setting1.jpeg'
import Settings2 from './setting2.jpeg'

const Instructions = () => {
    return (
        <div className='' >
            <div className='p-3 bg-custom-primary-500'>
                <p className='text-white text-[30px]'>Steps to Delete Your Account</p>
            </div>
            <div className='p-3'>
                <p className='text-[20px] my-4 font-bold'>Login to Your Account
                </p>
                <p>
                    1. Open the app and navigate to the login page. <br />
                    2. Enter your username or email address in the provided field.<br />
                    3. Type in your password.<br />
                    4. Click on the "Login" button to access your account.<br />
                </p>
                <p className='text-[20px] my-4 font-bold'>Navigate to Profile Settings
                </p>
                <p>
                    1. Within the sidebar menu, scroll through the options until you find  "Settings." or click to right top logo <br />
                    <img src={Settings1} className='w-[400px] h-[400px] object-contain' />
                </p>
                <p className='text-[20px] my-4 font-bold'>Click on Delete Profile:
                </p>
                <p>
                    1. In the "Profile Settings" section, look for the "Delete Profile" option. <br />
                    2. Click on "Delete Profile" to initiate the deletion process.
                </p>
                <p className='text-[20px] my-4 font-bold'>Confirm Your Decision: </p>
                <img src={Settings2} className='w-[400px] h-[400px] object-contain' />
            </div>
        </div>
    )
}

export default Instructions